import {
  formatDate,
  staffName,
  staffIsActive,
  staffAvatar,
  statusBadgeClass,
} from "./staffUtils";
import ActionsDropdown from "../resourcePersons/ActionsDropdown";

const StaffTable = ({
  staff,
  isReloading,
  onView,
  onEdit,
  onToggleStatus,
  onDelete,
  onActivity,
}) => {
  return (
    <table className="table mb-0 align-middle min-w-[900px]">
      <thead>
        <tr>
          <th></th>
          <th>Email</th>
          <th>Name</th>
          <th style={{ minWidth: "100px" }}>Updated</th>
          <th>Status</th>
          <th style={{ minWidth: "110px" }}>Date Added</th>
          <th>Phone</th>
          <th style={{ minWidth: "120px" }}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {isReloading && (
          <tr>
            <td colSpan={8}>
              <div className="d-flex justify-content-center align-items-center tableLoader">
                <div className="loader"></div>
              </div>
            </td>
          </tr>
        )}
        {!isReloading && staff.length === 0 && (
          <tr>
            <td colSpan={8}>
              <div className="d-flex justify-content-center align-items-center tableLoader">
                No staff members to display
              </div>
            </td>
          </tr>
        )}

        {staff.map((member, index) => {
          const active = staffIsActive(member);
          return (
            <tr key={member.id ?? index}>
              <td>
                {staffAvatar(member) ? (
                  <div className="adminProfileImage mx-2 s-35">
                    <img src={staffAvatar(member)} className="s-31" alt="Profile" />
                  </div>
                ) : (
                  <div className="adminProfileImage mx-2 s-35">
                    <img src="/images/default_profile.png" className="s-31" alt="Profile" />
                  </div>
                )}
              </td>
              <td className="text-start">{member.email}</td>
              <td>{staffName(member)}</td>
              <td>{formatDate(member.updatedAt || member.createdAt)}</td>
              <td>
                <span className={statusBadgeClass(member.status)}>
                  {member.status || (active ? "ACTIVE" : "INACTIVE")}
                </span>
              </td>
              <td>{formatDate(member.createdAt)}</td>
              <td>{member.phone || "--"}</td>
              <td>
                <ActionsDropdown
                  items={[
                    { label: "View Details", onClick: () => onView(member) },
                    { label: "Activity Log", onClick: () => onActivity(member) },
                    { label: "Edit", onClick: () => onEdit(member) },
                    {
                      label: active ? "Disable" : "Enable",
                      onClick: () => onToggleStatus(member),
                    },
                    {
                      label: "Delete",
                      danger: true,
                      onClick: () => onDelete(member),
                    },
                  ]}
                />
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default StaffTable;